import { DataHeader, DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBank extends Layout {
    dataheaderBank: DataHeader;
    sourceBank: DataSource;
    textboxBankName: Textbox;
    textboxId: Textbox;
}
